import axios from 'axios';

export const axiosBaseQuery =
    ({ baseUrl } = { baseUrl: '' }) =>
    async ({ url, method, data, params }) => {
        try {
            const result = await axios({ url: (baseUrl ? baseUrl : '') + url, method, data, params });
            return { data: result.data };
        } catch (err) {
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message
                }
            };
        }
    };
